var _desc, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgElogo2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 100,
    viewBox: "0 0 80 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.3.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.754509181 0 0 2.8354957707 21.6149620604 58.6791351809)",
    id: "PFAleANvXrO1F7tpOlaKn"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(106,49,171)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(247,47,58)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -10.36707 -5.96869 C -10.36707 -8.39785 -2.96661 -10.36707 6.162319999999999 -10.36707 L 6.162319999999999 -10.36707 L 6.162319999999999 -10.36707 C 8.484539999999999 -10.36707 10.367069999999998 -9.86614 10.367069999999998 -9.24821 L 10.367069999999998 5.9687 L 10.367069999999998 5.9687 C 10.367069999999998 8.39786 2.9666099999999984 10.367080000000001 -6.162320000000001 10.367080000000001 L -6.162320000000001 10.367080000000001 L -6.162320000000001 10.367080000000001 C -8.48454 10.367080000000001 -10.367070000000002 9.866150000000001 -10.367070000000002 9.248220000000002 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 0.6726640734 2.527916404 0 40 18.8986358491)",
    id: "VMrkCBaGTxm2nsFZK_zvR"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(106,49,171)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(105,105,105)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -10.36707 -5.96869 C -10.36707 -8.39785 -2.96661 -10.36707 6.162319999999999 -10.36707 L 6.162319999999999 -10.36707 L 6.162319999999999 -10.36707 C 8.484539999999999 -10.36707 10.367069999999998 -9.86614 10.367069999999998 -9.24821 L 10.367069999999998 5.9687 L 10.367069999999998 5.9687 C 10.367069999999998 8.39786 2.9666099999999984 10.367080000000001 -6.162320000000001 10.367080000000001 L -6.162320000000001 10.367080000000001 L -6.162320000000001 10.367080000000001 C -8.48454 10.367080000000001 -10.367070000000002 9.866150000000001 -10.367070000000002 9.248220000000002 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.5817640839 0 0 -1.5673460805 53.0442679366 81.101364152)",
    id: "GEEAU1Ikw6Otr9jAz7mTa"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(244,39,157)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(247,47,58)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -4.44928 -2.0154 C -4.44928 -3.3596000000000004 -3.78775 -4.44928 -2.97171 -4.44928 L 2.97171 -4.44928 L 2.97171 -4.44928 C 3.78775 -4.44928 4.44928 -3.35959 4.44928 -2.0154 L 4.44928 2.0153899999999996 L 4.44928 2.0153899999999996 C 4.44928 3.35959 3.78775 4.449269999999999 2.97171 4.449269999999999 L -2.97171 4.449269999999999 L -2.97171 4.449269999999999 C -3.78775 4.449269999999999 -4.44928 3.3595799999999993 -4.44928 2.0153899999999996 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.2989414814 0 0 1.7425802567 44.302366879 50.9257191332)",
    id: "4mDoJJ1Ujly80_eE2wq0c"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(244,39,157)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(105,105,105)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -4.44939 -2.74078 C -4.44939 -3.19393 -4.31294 -3.62852 -4.07006 -3.94895 C -3.82718 -4.26938 -3.4977599999999995 -4.44939 -3.15428 -4.44939 L 3.15428 -4.44939 L 3.15428 -4.44939 C 3.49776 -4.44939 3.8271800000000002 -4.26938 4.07006 -3.94895 C 4.31294 -3.62852 4.44939 -3.19393 4.44939 -2.74078 L 4.44939 2.7407899999999996 L 4.44939 2.7407899999999996 C 4.44939 3.68443 3.8695500000000003 4.449389999999999 3.15428 4.449389999999999 L -3.15428 4.449389999999999 L -3.15428 4.449389999999999 C -3.86955 4.449389999999999 -4.44939 3.6844199999999994 -4.44939 2.7407899999999996 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 0.6726640733 1.5443256528 0 48.208616879 81.101364152)",
    id: "YrXMvP2gq2qFz4jyR9G4n"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(106,49,171)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(247,47,58)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -10.36707 -3.16734 C -10.36707 -7.1436399999999995 -2.96661 -10.36707 6.162319999999999 -10.36707 L 6.162319999999999 -10.36707 L 6.162319999999999 -10.36707 C 8.484539999999999 -10.36707 10.367069999999998 -9.54709 10.367069999999998 -8.5356 L 10.367069999999998 3.1673399999999994 L 10.367069999999998 3.1673399999999994 C 10.367069999999998 7.1436399999999995 2.9666099999999984 10.367069999999998 -6.162320000000001 10.367069999999998 L -6.162320000000001 10.367069999999998 L -6.162320000000001 10.367069999999998 C -8.48454 10.367069999999998 -10.367070000000002 9.547089999999999 -10.367070000000002 8.535599999999999 z",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElogo2);
export default __webpack_public_path__ + "static/media/elogo2.8dab353e4315b9f37752cd0707fe1d1f.svg";
export { ForwardRef as ReactComponent };